import React from 'react';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import TireRepairIcon from '@mui/icons-material/TireRepair';
import OilBarrelIcon from '@mui/icons-material/OilBarrel';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

/** The home page's copy. No prices: every job is quoted after a look. */

export interface Service {
  icon: React.ReactNode;
  title: string;
  description: string;
  covers: string[];
}

export const services: Service[] = [
  {
    icon: <CarRepairIcon />,
    title: 'Engine & Diagnostics',
    description: 'Check-engine light on? We find the real cause before we touch a wrench.',
    covers: ['Scan-tool & scope diagnostics', 'Tune-ups & engine repair', 'Starters, alternators & wiring'],
  },
  {
    icon: <TireRepairIcon />,
    title: 'Brakes & Suspension',
    description: 'Stops straight, rides smooth, tracks true down the highway.',
    covers: ['Pads, rotors & calipers', 'Shocks, struts & ball joints', 'Alignments & tire service'],
  },
  {
    icon: <OilBarrelIcon />,
    title: 'Oil & Maintenance',
    description: 'The scheduled work that keeps a vehicle going past 200,000 miles.',
    covers: ['Synthetic & conventional oil', 'Fluids, filters & belts', 'State inspections'],
  },
  {
    icon: <AcUnitIcon />,
    title: 'A/C & Heating',
    description: 'Cold air in a Texas August, warm cab on a January morning.',
    covers: ['Recharge & leak testing', 'Compressors & condensers', 'Heater cores & blend doors'],
  },
  {
    icon: <SettingsIcon />,
    title: 'Transmission & Drivetrain',
    description: 'Slipping, shuddering or clunking — we chase it down to the part.',
    covers: ['Fluid service', 'Clutches & CV axles', 'Transfer cases & differentials'],
  },
  {
    icon: <LocalShippingIcon />,
    title: 'Trucks & Diesel',
    description: 'Half-tons, heavy-duty diesels and the trucks that tow for a living.',
    covers: ['Diesel diagnostics & injectors', 'DEF & emissions systems', 'Hitch wiring & towing setups'],
  },
];

export const guarantees = [
  'ASE-certified technicians',
  '24-month / 24,000-mile nationwide warranty',
  'Domestic, import & diesel',
  'Photos from the bay before we start work',
  'Your old parts, back in your hands',
  'Free courtesy shuttle around town',
];

export const stats = [
  { value: 12500, suffix: '+', label: 'Vehicles serviced' },
  { value: 4.9, decimals: 1, suffix: '★', label: 'Average rating' },
  { value: 24, suffix: ' mo', label: 'Warranty on repairs' },
  { value: 15, suffix: '+', label: 'Years on the tools' },
];

export const reviews = [
  {
    name: 'Cody Harlan',
    vehicle: '2019 Ford F-150',
    rating: 5,
    text: 'Two shops couldn’t chase down my check-engine light. Travis found a cracked vacuum line inside an hour and showed me the part. Straight shooters.',
  },
  {
    name: 'Danielle Ruiz',
    vehicle: '2017 Chevy Silverado 1500',
    rating: 5,
    text: 'They walked me through every line on the work order and texted photos from the lift. No pressure, no upsell — just honest work.',
  },
  {
    name: 'Wade Simmons',
    vehicle: '2020 Ram 2500 Cummins',
    rating: 5,
    text: 'Brought the diesel in with a sensor fault two days before a long haul. Back on the road that afternoon and it’s pulled like a champ since.',
  },
];

/** The Oakridge crew from the demo shop. */
export const crew = [
  { name: 'Jake Thompson', role: 'Master Technician', specialty: 'Engine & Drivetrain', years: 16, certifications: ['ASE Master', 'Diesel'] },
  { name: 'Travis McCall', role: 'Lead Technician', specialty: 'Brakes & Suspension', years: 12, certifications: ['ASE Master', 'Alignment'] },
  { name: 'Lacey Boudreaux', role: 'Diagnostic Specialist', specialty: 'Diagnostics & Electrical', years: 9, certifications: ['ASE L1', 'Hybrid'] },
  { name: 'Savannah Pruitt', role: 'Technician', specialty: 'Maintenance & Tires', years: 5, certifications: ['ASE Certified', 'Tire'] },
];
